import React from 'react';
import HomeView from 'views/HomeView';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setModal, setStickyNavVisiblity, setVideoOverlay } from 'state/actions/viewActions';
import get from 'utils/get';
import ResizableComponent from 'components/ResizableComponent';
import isMobile from 'utils/isMobile';
import { Status } from 'state/reducers/statusReducer';

class HomeContainer extends ResizableComponent {
  state = { isMobile: isMobile() }
  didResize(w, h, isMobile) {
    if (isMobile !== this.state.isMobile) this.setState({ isMobile });
  }

  componentWillReceiveProps(nextProps) {
    let emailSubmitFulfilled =
      (nextProps.emailStatus === Status.FULFILLED && this.props.emailStatus !== Status.FULFILLED);

    if (emailSubmitFulfilled) {
      this.props.history.push('/questionnaire');
      this.props.actions.setStickyNavVisiblity(false);
    }
  }

  render() {
    return (
      <HomeView
        setVideoOverlay={get(this, 'props.actions.setVideoOverlay')}
        setModal={get(this, 'props.actions.setModal')}
        setStickyNavVisiblity={get(this, 'props.actions.setStickyNavVisiblity')}
        isMobile={this.state.isMobile}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    emailStatus: get(state, 'statusState.submitEmail')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setVideoOverlay,
        setModal,
        setStickyNavVisiblity,
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js